// extracted by mini-css-extract-plugin
module.exports = {"cart-details":"CartDetails_cart-details__LmsUW"};